<template>
  <div>
    <div class="d-flex align-items-center">
      <FiveStars
        :filled-star-image-src="filledStarImageSrc"
        :filled-star-half-image-src="filledStarHalfImageSrc"
        :value="evaluationRound(value)"
        :size="size"
        class="mr-2"
      />
      <span class="mr-1" :class="`text-size-${textSize}`"
        >{{ evaluationRound(value) }}点</span
      >
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import FiveStars from "@/components/molecules/other/FiveStars.vue";
import { evaluationRound } from "@/utils/evaluationRound";

@Component({
  components: {
    FiveStars
  }
})
export default class EvaluationWithoutCount extends Vue {
  filledStarImageSrc = require("@/assets/svg/star/filled_star_yellow.svg");
  filledStarHalfImageSrc = require("@/assets/svg/star/filled_star_half_yellow.svg");
  @Prop({
    required: true,
    validator: prop => typeof prop === "number" || prop === null
  })
  value!: number | null;

  @Prop({
    default: "16",
    type: String
  })
  size!: string;

  @Prop({
    default: "14",
    type: String
  })
  textSize!: string;

  evaluationRound(value: number | null) {
    return evaluationRound(value);
  }
}
</script>
